import React from 'react';
import {
  string, shape, number, oneOf, func,
} from 'prop-types';
import isNil from 'lodash/isNil';
import { withI18n } from '@active/react-utils/i18n/LocaleContext';
import Locale from '@active/react-utils/i18n/Locale';
import { currency } from '../../../../../Currency';
import { currenciesConfig } from '../../../../../../../shared/utils/currenciesConfig';
import ActiveStatementMsgConfig from './ActiveStatementMsgConfig';
import { connectCommonProps } from '../../../../../../../shared/utils/CommonPropsContext';

const ActiveStatement = ({
  i18n, agency: { billingStatementName },
  paymentResult: { amount, currencyCode, paymentAccount: { tenderType, type } },
  locale,
}) => {
  const msgId = ActiveStatementMsgConfig[type] || ActiveStatementMsgConfig[tenderType];
  if (!tenderType || !msgId) {
    return null;
  }
  const currentCurrency = currenciesConfig(currencyCode);
  const currentAmount = !isNil(amount) && !isNil(currencyCode) ? currency({ amount, locale, code: currencyCode }) : '';
  const currentStatementName = billingStatementName || i18n('checkout.lib.components.paymentResult.detail.agencyInfo.defaultBillingStatementName');
  const values = { 0: currentCurrency, 1: currentAmount, 2: currentStatementName };

  return (
    <div className="active-statement">
      <div className="active-statement-title" >
        <Locale id={msgId} params={values} />
      </div>
    </div>
  );
};

ActiveStatement.propTypes = {
  locale: string,
  i18n: func.isRequired,
  agency: shape({
    billingStatementName: string,
  }),
  paymentResult: shape({
    amount: number,
    currencyCode: string,
    paymentAccount: shape({
      tenderType: string,
      type: oneOf([ 'ECP', 'EUDD' ]),
    }),
  }),
};

ActiveStatement.defaultProps = {
  agency: {},
  paymentResult: {
    paymentAccount: {},
  },
};

export default withI18n(connectCommonProps(ActiveStatement));
